<template
  ><div id="grad" class="w-screen h-screen">
    <div id="colorgrad"></div>
    <div id="all">
      <div id="container">
        <div id="logo">
          <img src="../../assets/qwello-logo.svg" alt="Qwello GmbH" />
        </div>
        <div v-if="tempPass || errMessage">
          <div id="text" class="pass-info">
            <h2 class="font-Foco">{{ $t('tech.resetpwd_site_title') }}</h2>
            <p id="intro">
              {{ $t('tech.resetpwd_site_intro') }}
            </p>
            <p class="error" :class="isError ? 'block' : 'hidden'">
              {{ errMessage }}
            </p>
            <p />
            <p class="instruction" :class="isError ? 'block' : 'hidden'">
              {{ $t('tech.resetpwd_site_error_user_instructions') }}
            </p>
          </div>

          <section id="temp_pass">
            <p class="number" :class="tempPass ? 'block' : 'hidden'">
              {{ tempPass }}
            </p>
            <p class="validity" :class="tempPass ? 'block' : 'hidden'">
              {{ $t('tech.login_site_tmp_validity') }}
            </p>
          </section>

          <div id="text" class="site-security">
            <p>
              {{ $t('tech.resetpwd_site_security') }}
            </p>
          </div>
        </div>
        <Spinner v-else />
        <store-links />

        <bottom-icons />
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '@/i18n';
import StoreLinks from '../../components/Tech/StoreLinks.vue';
import BottomIcons from '../../components/Tech/BottomIcons.vue';
import Spinner from '../../components/shared/Spinner.vue';

export default {
  components: {
    StoreLinks,
    BottomIcons,
    Spinner,
  },
  data() {
    return {
      isError: false,
      errMessage: '',
      tempPass: '',
    };
  },
  async beforeCreate() {
    const response = await fetch(
      // eslint-disable-next-line
      `${process.env.VUE_APP_USER_SERVICE_URL}/login/get-temp-pass?user_id=${this.$route.params.userId}&user_token=${this.$route.params.token}&language=${i18n.locale}`
    );
    const body = await response.json();
    if (response.status === 200) {
      const { data } = body;
      this.tempPass = data.temp_pass;
      this.appUrl = `eu.qwello.app://qwicc.com/app/login/${this.$route.params.userId}/${this.$route.params.token}`;
      return true;
    }
    this.isError = true;
    this.errMessage = body.message;
    return true;
  },
};
</script>

<style scoped>
h2 {
  display: block;
  font-size: 1.5em;
  margin-top: 0.83em;
  margin-bottom: 0.83em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}

p {
  display: block;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 0;
  margin-right: 0;
}

a {
  text-decoration: underline;
  cursor: auto;
}

#grad {
  margin: 0;
  padding: 0;
}

#grad {
  background-image: url(~@/assets/registration_confirmation_lp.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  color: #fff;
  font-family: 'lato', sans-serif;
  font-weight: 400;
}

#colorgrad {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background: -webkit-linear-gradient(
    top,
    rgba(43, 64, 71, 0.7),
    rgba(65, 85, 92, 0.7)
  );
  background: -o-linear-gradient(
    top,
    rgba(43, 64, 71, 0.7),
    rgba(65, 85, 92, 0.7)
  );
  background: linear-gradient(
    to bottom,
    rgba(43, 64, 71, 0.7),
    rgba(65, 85, 92, 0.7)
  );
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  overflow: auto;
}

#all {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 40;
  overflow: auto;
  text-align: center;
}

#container {
  min-height: 100%;
  align-content: center;
  text-align: center;
  margin: 0 auto;
}

#logo {
  width: 100%;
  display: block;
}

#text {
  text-align: center;
  display: block;
  width: 100%;
}

h2 {
  color: #fff;
  font-family: 'Foco', sans-serif;
  font-weight: 700;
  letter-spacing: 0.5px;
}

p {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

#temp_pass .number {
  background-color: rgba(255, 223, 34, 0.1);
  width: 86px;
  height: 38px;
  text-align: center;
  color: #ffdf22;
  font-size: 18px;
  font-weight: 700;
  line-height: 38px;
  vertical-align: middle;
  margin: 0 auto;
}

#temp_pass .validity {
  font-size: 14px;
  opacity: 0.5;
  font-weight: 700;
  margin-top: 0;
  user-select: none;
}

.hidden {
  visibility: hidden !important;
}

#btn {
  margin-top: 50px;
}

#btn a {
  background-color: #ffdf22;
  border: 2px solid #ffdf22;
  border-radius: 50px;
  color: #2b4047;
  display: inline-block;
  font-family: 'lato', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  text-decoration: none;
  width: 294px;
  height: 30px;
}

#btn a:hover {
  background-color: #ffdf22;
  color: #2b4047;
  transition: 0.1s;
}

@media screen and (min-width: 600px) {
  #container {
    width: 70%;
  }

  #logo img {
    margin: 100px 0;
    width: 150px;
    margin-left: auto;
    margin-right: auto;
  }

  h2 {
    font-size: 24px;
    line-height: 25px;
  }

  p {
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 1px;
  }
}

@media screen and (max-width: 599px) {
  #container {
    margin-left: 20px;
    margin-right: 20px;
  }

  #logo img {
    margin-top: 60px;
    margin-bottom: 40px;
    width: 125px;
  }

  h2 {
    font-size: 18px;
    line-height: 19px;
  }

  p {
    font-size: 16px;
    line-height: 19px;
  }
}
</style>
